import Loader from '@platform-ui/loader';
import cn from 'classnames';
import React from 'react';
import { getUrlParam } from '../../utils/get-url-param';
import styles from './LoaderOverlay.module.css';

export const LoaderOverlay: React.FC<{ isWebview: boolean }> = ({ isWebview }) => {
  return <LoaderOverlayStandalone isWebview={isWebview} />;
};

export const LoaderOverlayStandalone: React.FC<{ isWebview: boolean }> = ({ isWebview }) => {
  const heightGrow = getUrlParam('height_grow') !== 'off';
  const rootStyle = { height: heightGrow ? '100%' : 'auto', transition: 'height 5s ease-out' };
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition

  return (
    <div id="content" style={rootStyle}>
      <div aria-label="Загрузка" className={cn(styles.root, isWebview && styles.webview)}>
        <Loader color={'var(--tui-background-accent-1)'} />
      </div>
    </div>
  );
};
